import { Mailbox } from "lucide-react";

import { getModelLink } from "components/LogItem/messages/modelLinks";

const contactLinkFor = ({ contact_id, contact_name }) =>
  getModelLink(contact_id, "Contact", { label: contact_name });

export const MAIL_EVENTS = {
  mail_mailed: {
    title: "Mail Sent",
    icon: Mailbox,
    message: item => <p>Mail was sent to {contactLinkFor(item)}.</p>,
  },
  mail_delivered: {
    title: "Mail Delivered",
    icon: Mailbox,
    message: item => <p>{contactLinkFor(item)} received mail.</p>,
  },
};
